import React, {
  useContext,
  useState,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import styled from "styled-components";
import { LanguageModal } from "./LanguageModal";
import { SiteSelectionModal } from "./SiteSelectionModal";
import { HeaderLeftSection } from "./HeaderLeftSection";
import { SiteSelector } from "./SiteSelector";
import { AccountMenuButton } from "./AccountMenuButton";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MoreIcon from "@mui/icons-material/MoreVert";
import { Modal, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import { AuthContext } from "auth/Auth";
import { useHookstate } from "@hookstate/core";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import _ from "lodash";
import moment from "moment";
import { useSnackbar } from "notistack";
import LanguageMenuIcon from "assets/svgIcons/LanguageMenuIcon";
import LogoutIcon from "assets/svgIcons/LogOutIcon";
import UnLockIcon from "assets/svgIcons/UnlockMenuIcon";
import GlobeIcon from "assets/svgIcons/GlobeIcon";
import {
  SIDENAV_GLOBAL_STATE,
  FLEET_GLOBAL_STATES,
  MAP_GLOBAL_STATES,
  SITELOCATION_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  CHECKBOX_LOADER,
  GlobalCourseIdState,
  GLOBAL_SITE_SEARCH,
  APP_CONSTANTS_STATE,
  COMMON_COMPONENTS_STATES,
  LANGUAGE_GLOBAL_STATE,
  ADS_GLOBAL_STATE,
  MAX_HOLES_GLOBAL_STATE,
} from "../../globalStore/globalStore";
import Logo from "assets/images/club-car-connect-logo.png";
import {
  Container,
  ChangePasswordPopup,
} from "commonComponents/Navbar/NavbarStyled";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  setSiteIdData,
  setViewDistanceYardsAction,
  setAppDataReduxStateAction,
} from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { PopUpContainer } from "assets/css/globle";

export const Navbar = () => {
  const { closeSnackbar } = useSnackbar();

  const { siteSearchValue, isFirstUpdate } = useHookstate(GLOBAL_SITE_SEARCH);
  const { localSiteTimeState, findCars } = useHookstate(COMMON_COMPONENTS_STATES);
  const { selectedLang } = useHookstate(LANGUAGE_GLOBAL_STATE);
  const { detectChangeMaxHolesAllowed } = useHookstate(MAX_HOLES_GLOBAL_STATE);
  const { globalCourseId, resetGlobalCourseId } = useHookstate(GlobalCourseIdState);
  const { redirectState, alertMsg, nextStageName } = useHookstate(ADS_GLOBAL_STATE);
  const { getCarsCounter } = useHookstate(APP_CONSTANTS_STATE);
  const { LoadingState } = useHookstate(CHECKBOX_LOADER);

  const {
    sideDrawerState,
    sideDrawerActiveTabState,
    subNavDataState,
  } = useHookstate(SIDENAV_GLOBAL_STATE);

  const {
    siteLocationGlobalData,
    singleSiteLocationData,
    dropDownEvent
  } = useHookstate(SITELOCATION_GLOBAL_STATE);

  const {
    siteId,
    selectSite,
    hideSubNav,
    hasSiteChangedAds,
  } = useHookstate(SITEID_GLOBAL_STATE);

  const {
    weatherAlertGlobalState,
    weatherAlertPopUpDisplayer,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const {
    addActionZonePolygon,
    openActionZoneWindow,
    getSelectedCarsState,
    callSiteSelection,
    siteListPopupOpen,
    openAZdiscardPopup,
    showTaggedCarArrayClickToDriveInputValueSetter,
    showTaggedCarArrayClickToDrive,
    mapSideNavTabState,
    taggedCarsSaverGlobalState,
    showTaggedCarArray,
    taggedCarsDisplayerGlobalState,
  } = useHookstate(MAP_GLOBAL_STATES);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { handleLogout } = useContext(AuthContext);

  const {
    siteLocationsData,
    siteSettingsData,
    getChangePasswordState,
    getUserRole,
  } = useSelector((state) => state.commonReducers) || {};

  const {
    siteIdData,
    appDataReduxState: { distanceunits } = {},
  } = useSelector((state) => state.firstReducer) || {};

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showConfirmChangePasswordModal, setshowConfirmChangePasswordModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [siteSelectionHistory, setSiteSelectionHistory] = useState(true);
  const [siteList] = useState([]);
  const [recentThreeSiteState, setRecentThreeSiteState] = useState(null);
  const [open, setOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [siteSelectionEvent, setSiteSelectionEvent] = useState(null);
  const [startDateData] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [endDateData] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [time, setTime] = useState(null);
  const [sortConfig, setSortConfig] = useState({ field: "Name", isAscending: true });
  const [nameSortActive, setNameSortActive] = useState(true);
  const [idSortActive, setIdSortActive] = useState(false);
  const [showInternal, setShowInternal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedSite, setSelectedSite] = useState("Choose Site..");
  const [language, setLanguage] = useState("English");

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleClose2 = () => {
    setOpen(false);
  }

  const handleLanguage = () => {
    setAnchorEl(null);
    setOpen(true);
  }

  const tick = useCallback(() => {
    let formattedTime =
      new Date().toLocaleTimeString();

    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0 && !_.isNull(siteSettingsData?.TimeZoneOffset)) {
      formattedTime = moment()
        .utcOffset(-siteSettingsData.TimeZoneOffset)
        .format("HH:mm");

      localSiteTimeState.set(formattedTime);
    }

    setTime(formattedTime);
  }, [siteSettingsData, localSiteTimeState]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  }

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  }

  const OpenUrl = () => {
    const url = "https://help.visage.golf/visage-2/";
    window.open(url, "_blank");
  }

  const onClickSideBar = () => {
    if (window.innerWidth > 850) {
      hideSubNav.set(false);
      sideDrawerState.set(!sideDrawerState.get());
    } else {
      hideSubNav.set(true);
      sideDrawerState.set(!sideDrawerState.get());
    }
  }

  useEffect(() => {
    const timerID = setInterval(tick, 1000);

    return () => clearInterval(timerID);
  }, [siteSettingsData, tick]);

  useEffect(() => {
    weatherAlertGlobalState.set(siteSettingsData?.WeatherAlert);
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getAllSiteLocationsServices());
  }, []);

  useEffect(() => {
    if (siteId.get() !== null) {
      siteListPopupOpen.set(false);

      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      dispatch(COMMON_SERVICES.getFeatureSetServices(siteId.get()));
      dispatch(setSiteIdData(siteId.get()));

      if (siteLocationsData && siteLocationsData.length > 0) {
        const selectedSiteName = siteLocationsData.find((item) => item.Id === siteId.get())?.Name;

        if (selectedSiteName) {
          setSelectedSite(selectedSiteName);
        }
      }
    }
  }, [siteId.get()]);

  useEffect(() => {
    if (getChangePasswordState && getChangePasswordState?.success) {
      setShowChangePasswordModal(false);
      setshowConfirmChangePasswordModal(true);

      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  }, [getChangePasswordState]);

  useEffect(() => {
    if (!siteLocationsData?.length) return;

    // Only one site: automatically select it
    if (siteLocationsData.length === 1) {
      const selectedSiteId = siteLocationsData[0].Id;

      siteId.set(selectedSiteId);
      siteLocationGlobalData.set(false);

      localStorage.setItem("recentSite", JSON.stringify(selectedSiteId));
      localStorage.setItem("RecentThreeSites", JSON.stringify([selectedSiteId]));

      return;
    }

    // Multiple sites
    const storedRecentSite = localStorage.getItem("recentSite");

    const recentSite = siteLocationsData.find(
      ({ Id }) => Id.toString() === storedRecentSite
    );

    // Recent site no longer exists
    if (!recentSite) {
      siteId.set(null);
      siteLocationGlobalData.set(true);
      localStorage.removeItem("recentSite");

      return;
    }

    // Restore recent site if nothing is currently selected
    if (!selectSite.get()) {
      siteId.set(recentSite.Id);
      siteLocationGlobalData.set(false);
      setSelectedSite([recentSite.Name]);
    }
  }, [siteLocationsData]);


  // Filter sites based on search text
  const filteredData = useMemo(() => {
    if (!siteLocationsData?.length) {
      return [];
    }

    const search = searchText?.toUpperCase() ?? "";

    return siteLocationsData.filter(({ Id, Name }) => {
      return (
        Id.toString().toUpperCase().includes(search) ||
        Name.toString().toUpperCase().includes(search)
      );
    });
  }, [siteLocationsData, searchText]);


  // Sort filtered sites
  const sortedSites = useMemo(() => {
    if (!filteredData.length) {
      return [];
    }

    return [...filteredData].sort((a, b) => {
      if (sortConfig.field === "Id") {
        return sortConfig.isAscending
          ? a.Id - b.Id
          : b.Id - a.Id;
      }

      if (sortConfig.field === "Name") {
        return sortConfig.isAscending
          ? a.Name.localeCompare(b.Name)
          : b.Name.localeCompare(a.Name);
      }

      return 0;
    });
  }, [filteredData, sortConfig]);

  useEffect(() => {
    if (siteIdData) {
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    }

    let getThreeSite = JSON.parse(localStorage.getItem("RecentThreeSites"));

    if (getThreeSite !== null) {
      siteList.push(...getThreeSite.flat(1));
    }
  }, []);

  useEffect(() => {
    if (siteId.get() !== null) {
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    }
  }, [siteIdData]);

  useEffect(() => {
    dispatch(setViewDistanceYardsAction(distanceunits));
  }, [siteIdData]);

  useEffect(() => {
    selectedLang.set(i18next.language);
  }, [i18next.language]);

  useEffect(() => {
    if (callSiteSelection.get()) {
      callSiteSelection.set(false);
      siteLocation(siteSelectionEvent);
    }
  }, [callSiteSelection.get()]);

  useEffect(() => {
    extractRecentData();
  }, [siteListPopupOpen.get()]);

  const siteLocation = (event) => {
    showTaggedCarArrayClickToDriveInputValueSetter.set([]);
    showTaggedCarArrayClickToDrive.set([]);
    taggedCarsSaverGlobalState.set([]);
    showTaggedCarArray.set([]);
    taggedCarsDisplayerGlobalState.set(false);
    findCars.set(false);

    localStorage.removeItem("taggedCarsData");
    localStorage.removeItem("isTaggedCar");

    event.preventDefault();

    setSiteSelectionEvent(event);

    if (redirectState.get()) {
      alertMsg.set(true);
      nextStageName.set("siteSelection");
    } else {
      if (event.target.id === "") {
        return;
      }

      let selectedSiteId = parseInt(event.target.id);

      setSelectedSite(siteLocationsData?.filter((item) => item.Id == selectedSiteId)?.map((data) => data.Name));

      localStorage.setItem("dashCourseId", resetGlobalCourseId.get());

      globalCourseId.set(resetGlobalCourseId.get());

      getCarsCounter.set(0);

      subNavDataState.set(localStorage.getItem("subNavDataState"));

      siteLocationGlobalData.set(false);

      if (siteId.get() === null) {
        selectSite.set(false);

        siteId.set(selectedSiteId);
        singleSiteLocationData.set(true);
        dropDownEvent.set(true);

        localStorage.setItem("recentSite", event.target.id);

        dispatch(setAppDataReduxStateAction({ parameterDetector: "sitenumber", value: event.target.id }));

        dispatch(setSiteIdData(event.target.id));

        dispatch(COMMON_SERVICES.getSiteSettingsServices(event.target.id));

        dispatch(COMMON_SERVICES.getCampaignsServices(event.target.id));

        dispatch(COMMON_SERVICES.getScoreCardServices(event.target.id, startDateData, endDateData));

        dispatch(COMMON_SERVICES.getImageGalleryServices(event.target.id));

        let recentSitesData = JSON.parse(localStorage.getItem("RecentThreeSites"));

        recentSitesData = _.without(recentSitesData, selectedSiteId);

        recentSitesData.unshift(selectedSiteId);

        while (recentSitesData.length > 3) {
          recentSitesData.pop();
        }

        localStorage.setItem("RecentThreeSites", JSON.stringify(recentSitesData));

        if (siteListPopupOpen.get()) {
          siteListPopupOpen.set(false);
        } else {
          siteListPopupOpen.set(true);
        }

        siteSearchValue.set("");
      } else {
        selectSite.set(false);
        siteId.set(selectedSiteId);
        siteLocationGlobalData.set(false);
        singleSiteLocationData.set(true);
        dropDownEvent.set(true);

        localStorage.setItem("recentSite", event.target.id);

        dispatch(setAppDataReduxStateAction({ parameterDetector: "sitenumber", value: event.target.id }));

        dispatch(setSiteIdData(event.target.id));

        dispatch(COMMON_SERVICES.getSiteSettingsServices(event.target.id));

        dispatch(COMMON_SERVICES.getCampaignsServices(event.target.id));

        dispatch(COMMON_SERVICES.getScoreCardServices(event.target.id, startDateData, endDateData));

        dispatch(COMMON_SERVICES.getImageGalleryServices(event.target.id));

        dispatch(COMMON_SERVICES.getCarServices(true, siteId.get()))?.then(() => isFirstUpdate.set(true));

        let recentSitesData = JSON.parse(localStorage.getItem("RecentThreeSites"));

        recentSitesData = _.without(recentSitesData, selectedSiteId);

        recentSitesData.unshift(selectedSiteId);

        while (recentSitesData.length > 3) {
          recentSitesData.pop();
        }

        localStorage.setItem("RecentThreeSites", JSON.stringify(recentSitesData));

        siteListPopupOpen.set(!siteListPopupOpen.get());

        siteSearchValue.set("");
        getSelectedCarsState.set([]);
        detectChangeMaxHolesAllowed.set(false);
      }

      openActionZoneWindow.set(false);

      hasSiteChangedAds.set(mapSideNavTabState.get() == "editCampaign");
    }
  }

  const extractRecentData = () => {
    let getStorageData = JSON.parse(localStorage.getItem("RecentThreeSites"));

    let loopData =
      getStorageData &&
      getStorageData?.map((item) => {
        let filterValue =
          siteLocationsData?.filter(
            (childItem) =>
              childItem.Id == item
          );

        return filterValue;
      });

    setRecentThreeSiteState(loopData?.flat(1));

    return loopData;
  }

  const handleClick = () => {
    if (siteListPopupOpen.get()) {
      siteListPopupOpen.set(false);
    } else {
      siteListPopupOpen.set(true);
    }
  }

  const handleClose = () => siteListPopupOpen.set(false);

  const allSiteFunction = () => {
    selectSite.set(true);

    let pathName = window.location.pathname;

    if (pathName !== "/map") {
      navigate("/map");
      sideDrawerActiveTabState.set(1);
      subNavDataState.set("MAP");
    }

    setTimeout(() => {
      siteLocationGlobalData.set(true);
      closeSnackbar();

      subNavDataState.set("");
      siteListPopupOpen.set(false);
    }, 500);
  }

  const handleAlertClick = (identification, alertDetector) => {
    if (alertDetector) {
      weatherAlertGlobalState.set(alertDetector);

      LoadingState.set(true);

      dispatch(COMMON_SERVICES.putFleetSettingsServices({ code: identification, Value: alertDetector }, siteId.get()));

      setTimeout(() => {
        LoadingState.set(false);
      }, 2000);

      weatherAlertPopUpDisplayer.set(false);
    } else {
      weatherAlertGlobalState.set(
        alertDetector
      );

      LoadingState.set(true);

      dispatch(
        COMMON_SERVICES.putFleetSettingsServices(
          {
            code: identification,
            Value: false,
          },
          siteId.get()
        )
      );

      setTimeout(() => {
        LoadingState.set(false);
      }, 2000);

      weatherAlertPopUpDisplayer.set(false);
    }
  }

  const showPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "100%",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={weatherAlertPopUpDisplayer.get()}
        onClose={() =>
          weatherAlertPopUpDisplayer.set(false)
        }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2 }}
            >
              Engage weather alert
            </Typography>

            <div
              className="action-btn"
              style={{ marginTop: 20 }}
            >
              <button
                onClick={() =>
                  handleAlertClick(
                    "WA",
                    true
                  )
                }
                className="primary"
              >
                {t("Yes")}
              </button>

              <button
                onClick={() =>
                  handleAlertClick(
                    "WA",
                    false
                  )
                }
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  }

  const handleChangePassword = (e) => {
    e.preventDefault();

    let changePasswordFormData = {
      OldPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmPassword,
    };

    dispatch(
      COMMON_SERVICES.postChangePasswordService(
        changePasswordFormData
      )
    );
  }

  const showChangePasswordPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "100%",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showChangePasswordModal}
        onClose={() =>
          setShowChangePasswordModal(false)
        }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ChangePasswordPopup>
            <div className="header">
              {t("Change_Password")}
            </div>

            <form
              type="submit"
              onSubmit={(e) =>
                handleChangePassword(e)
              }
              className="form-style"
            >
              <p id="modal-modal-description">
                {t("Current_password")}
              </p>

              <input
                type="password"
                name="OldPassword"
                value={oldPassword}
                onChange={(e) =>
                  setOldPassword(
                    e.target.value
                  )
                }
              />

              <p id="modal-modal-description">
                {t("New_password")}
              </p>

              <input
                type="password"
                name="NewPassword"
                value={newPassword}
                onChange={(e) =>
                  setNewPassword(
                    e.target.value
                  )
                }
              />

              <p id="modal-modal-description">
                {t("Confirm_new_password")}
              </p>

              <input
                type="password"
                name="ConfirmPassword"
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(
                    e.target.value
                  )
                }
              />

              <ul className="password-text">
                {getChangePasswordState &&
                  Object.keys(
                    getChangePasswordState
                  ).length !== 0 &&
                  getChangePasswordState?.errors
                    .length !== 0 ? (
                  <>
                    {getChangePasswordState?.errors?.map(
                      (item) => {
                        return (
                          <li key={item}>
                            {item}
                          </li>
                        );
                      }
                    )}
                  </>
                ) : (
                  <></>
                )}
              </ul>

              <div className="action-wrapper">
                <button
                  type="button"
                  onClick={() => {
                    setShowChangePasswordModal(
                      false
                    );

                    dispatch(
                      COMMON_SERVICES.resetStateChangePasswordService()
                    );

                    setOldPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                  }}
                >
                  {t("Cancel")}
                </button>

                <input
                  type="submit"
                  value={t("Save")}
                />
              </div>
            </form>
          </ChangePasswordPopup>
        </Box>
      </Modal>
    );
  }

  const showChangePasswordConfirmationPopupBox =
    () => {
      const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform:
          "translate(-50%, -50%)",
        maxWidth: "400px",
        width: "100%",
        bgcolor: "#fff",
        borderRadius: "5px",
        overflow: "hidden",
      };

      return (
        <Modal
          open={
            showConfirmChangePasswordModal
          }
          onClose={() =>
            setshowConfirmChangePasswordModal(
              false
            )
          }
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <PopUpContainer>
              <h4>Password Changed</h4>

              <div className="action-btn">
                <button
                  onClick={() => {
                    setshowConfirmChangePasswordModal(
                      false
                    );
                  }}
                >
                  {t("Ok")}
                </button>
              </div>
            </PopUpContainer>
          </Box>
        </Modal>
      );
    };

  const logoutUser = (data) => {
    if (data === "logout") {
      localStorage.removeItem("vkey");
      localStorage.removeItem(
        "mapSideNavTabState"
      );
      localStorage.removeItem(
        "subNavDataState"
      );
      localStorage.removeItem("subNavState");
      localStorage.removeItem(
        "sideDrawerActiveTabState"
      );

      dispatch(
        COMMON_SERVICES.resetStateChangePasswordService()
      );

      handleLogout();

      hideSubNav.set(false);

      navigate("/");
    }
  }

  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      className="hello"
    >
      <TopMenuDropdown>
        <EmailIdMenu>
          <p>
            {getUserRole &&
              getUserRole?.Name}
          </p>

          <span>
            {t("VCC_Version_Number") +
              " " +
              process.env
                .REACT_APP_PIPELINE_BUILD_NUMBER}
          </span>
        </EmailIdMenu>

        <MenuItem
          onClick={handleLanguage}
        >
          <MenuItemLi>
            <span>
              <LanguageMenuIcon />
            </span>

            {t("Language")}
          </MenuItemLi>
        </MenuItem>

        <MenuItem
          onClick={OpenUrl}
          sx={{
            display: {
              sm: "block",
              md: "none",
            },
          }}
        >
          <MenuItemLi>
            <span>
              <HelpOutlineIcon />
            </span>

            {t("Help")}
          </MenuItemLi>
        </MenuItem>

        <MenuItem
          onClick={() =>
            setShowChangePasswordModal(
              true
            )
          }
        >
          <MenuItemLi>
            <span>
              <UnLockIcon />
            </span>

            {t("Change_Password")}
          </MenuItemLi>
        </MenuItem>

        <MenuItem
          onClick={() =>
            logoutUser("logout")
          }
        >
          <MenuItemLi>
            <span>
              <LogoutIcon />
            </span>

            {t("Logout")}
          </MenuItemLi>
        </MenuItem>
      </TopMenuDropdown>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem
        onClick={handleMenuClose}
      >
        Profile
      </MenuItem>

      <MenuItem onClick={handleLanguage}>
        {t("Language")}
      </MenuItem>

      <MenuItem
        onClick={() =>
          logoutUser("logout")
        }
      >
        {t("Logout")}
      </MenuItem>
    </Menu>
  );

  const showAllSitesStyle = {
    display: {
      xs: "none",
      md: "flex",
    },
    padding: "0 15px 0 0",
    borderRight:
      "1px solid #E5E5E5;",
    height: "100%",
    alignItems: "center",
    cursor: siteLocationGlobalData.get()
      ? "not-allowed"
      : "pointer",
    background: "#fff",
  };

  const languageModal = (
    <LanguageModal
      open={open}
      onClose={handleClose2}
      language={language}
      setLanguage={setLanguage}
      onConfirm={() => {
        i18next.changeLanguage(language);
        setOpen(false);
      }}
    />
  );

  const siteSelectionModal = (
    <SiteSelectionModal
      open={siteListPopupOpen.get()}
      onClose={handleClose}
      siteId={siteId.get()}
      siteSelectionHistory={
        siteSelectionHistory
      }
      setSiteSelectionHistory={
        setSiteSelectionHistory
      }
      recentThreeSiteState={
        recentThreeSiteState
      }
      sortedSites={sortedSites}
      sortConfig={sortConfig}
      showInternal={showInternal}
      setShowInternal={setShowInternal}
      nameSortActive={nameSortActive}
      idSortActive={idSortActive}
      setIdSortActive={
        setIdSortActive
      }
      setNameSortActive={
        setNameSortActive
      }
      setSortConfig={setSortConfig}
      siteLocation={siteLocation}
      allSiteFunction={allSiteFunction}
      setSearchText={setSearchText}
    />
  );

  return (
    <>
      {subNavDataState.get().toUpperCase() !== "MAP" || window.innerWidth < 850 ? (
        <Container className="for-other-section-header">
          <Box sx={{ flexGrow: 1 }}>
            <AppBar
              position="static"
              sx={{
                height: "56px",
                bgcolor: "#fff",
                color: "#000",
              }}
              elevation={2}
              className="header-app"
            >
              <Toolbar
                sx={{
                  paddingLeft: {
                    xs: "15px",
                    sm: "0",
                  },
                  paddingRight: {
                    xs: "0",
                    sm: "0",
                  },
                  minHeight: "56px",
                }}
              >
                <HeaderLeftSection
                  logo={Logo}
                  version={process.env.REACT_APP_PIPELINE_BUILD_NUMBER}
                  sideDrawerState={sideDrawerState.get()}
                  onClickSideBar={onClickSideBar}
                  OpenUrl={OpenUrl}
                />

                {weatherAlertGlobalState.get() ? (
                  <Box
                    sx={{
                      border:
                        "4px solid #E5E5E5",
                      borderColor: "red",
                      fontSize: "13px",
                    }}
                  >
                    <p>
                      {t(
                        "Weather_Alert_Engaged"
                      )}
                    </p>
                  </Box>
                ) : (
                  <></>
                )}

                <Box sx={{ flexGrow: 1 }} />

                {languageModal}

                {siteLocationsData?.length > 1 &&
                  <>
                    {!selectSite.get() && siteId.get() !== null && (
                      <Tooltip
                        title={t("Show_all_sites")}
                        placement="left"
                        arrow
                      >
                        <Box sx={showAllSitesStyle}>
                          <IconButton onClick={allSiteFunction}>
                            <GlobeIcon />
                          </IconButton>
                        </Box>
                      </Tooltip>
                    )}

                    <SiteSelector
                      selectedSite={selectedSite}
                      onClick={handleClick}
                      siteId={siteId.get()}
                      selectSite={selectSite.get()}
                      time={time}
                    />
                  </>
                }

                {siteSelectionModal}

                <AccountMenuButton
                  menuId={menuId}
                  onClick={
                    handleProfileMenuOpen
                  }
                />

                <Box
                  sx={{
                    display: {
                      xs: "none",
                      md: "none",
                    },
                  }}
                >
                  <IconButton
                    size="large"
                    aria-label="show more"
                    aria-controls={
                      mobileMenuId
                    }
                    aria-haspopup="true"
                    onClick={
                      handleMobileMenuOpen
                    }
                    color="inherit"
                  >
                    <MoreIcon />
                  </IconButton>
                </Box>
              </Toolbar>
            </AppBar>

            {renderMobileMenu}
            {renderMenu}
          </Box>

          {showPopupBox()}
          {showChangePasswordPopupBox()}
          {showChangePasswordConfirmationPopupBox()}
        </Container>
      ) : (
        <>
          <div className="for-map-header-left-section">
            <HeaderLeftSection
              logo={Logo}
              version={process.env.REACT_APP_PIPELINE_BUILD_NUMBER}
              sideDrawerState={sideDrawerState.get()}
              onClickSideBar={onClickSideBar}
              OpenUrl={OpenUrl}
            />

            {weatherAlertGlobalState.get() ? (
              <Box
                sx={{
                  border:
                    "4px solid #E5E5E5",
                  borderColor: "red",
                  width: "173px",
                  fontSize: "13px",
                }}
              >
                <p>
                  {t(
                    "Weather_Alert_Engaged"
                  )}
                </p>
              </Box>
            ) : (
              <></>
            )}

            {languageModal}
          </div>

          <div className="for-map-header-right-section">
            {siteLocationsData?.length > 1 &&
              <>
                <Tooltip title={t("Show_all_sites")} placement="left">
                  <Box
                    sx={{
                      display: {
                        xs: "none",
                        md: "flex",
                      },
                      padding:
                        "0 15px ",
                      borderRight:
                        "1px solid #E5E5E5;",
                      height: "100%",
                      alignItems:
                        "center",
                      cursor:
                        "pointer",
                      background:
                        "#fff",
                    }}
                    onClick={() => {
                      if (
                        addActionZonePolygon.get()
                      ) {
                        openAZdiscardPopup.set(
                          true
                        );
                        redirectState.set(
                          false
                        );
                      } else {
                        allSiteFunction();
                      }
                    }}
                  >
                    <GlobeIcon />
                  </Box>
                </Tooltip>

                <SiteSelector
                  selectedSite={selectedSite}
                  onClick={handleClick}
                  siteId={siteId.get()}
                  selectSite={selectSite.get()}
                  time={time}
                />
              </>
            }

            {siteSelectionModal}

            <AccountMenuButton
              menuId={menuId}
              onClick={
                handleProfileMenuOpen
              }
            />

            <Box
              sx={{
                display: {
                  xs: "none",
                  md: "none",
                },
              }}
            >
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={
                  mobileMenuId
                }
                aria-haspopup="true"
                onClick={
                  handleMobileMenuOpen
                }
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </Box>
          </div>

          {renderMobileMenu}
          {renderMenu}

          {showPopupBox()}
          {showChangePasswordPopupBox()}
          {showChangePasswordConfirmationPopupBox()}
        </>
      )}
    </>
  );
};

const MenuItemLi = styled.div`
  display: grid;
  grid-template-columns: 32px auto;
  align-items: center;
  min-width: 150px;
  gap: 10px;
  font-size: 16px;
  width: 100%;
  min-height: 49px;

  &.bdr-tp {
    border-top: 1px dashed #00000080;
    padding-top: 10px;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const EmailIdMenu = styled.div`
  p {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    padding: 0 15px;
    white-space: nowrap;
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    font-weight: 200;
    font-size: 16px;
    line-height: 40px;
    padding: 0 30px;
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  display: inline-block;
  align-items: center;
  min-height: 58px;
  border-bottom: 1px solid #eeeeee;
  margin: 0 10px 8px;
`;

const TopMenuDropdown = styled.ul`
  padding: 0 10px;

  > li:hover {
    background: #f2f6ff;
    border-radius: 15px;
    color: #0093dd;
  }
`;
